import { render } from "./TextFormattingBar.vue?vue&type=template&id=8d633714"
import script from "./TextFormattingBar.vue?vue&type=script&lang=js"
export * from "./TextFormattingBar.vue?vue&type=script&lang=js"

import "./TextFormattingBar.vue?vue&type=style&index=0&id=8d633714&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__